import { useState } from "react";
import { toast } from "sonner";
import { Check, Crown, Lightning } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { startCheckout, formatBRL } from "@/lib/gado";
import { useAuth } from "@/context/AuthContext";

const FREE_FEATURES = [
  "Pesagens ilimitadas",
  "Cálculo automático de arrobas e frete",
  "Cadastros de compradores e fazendas",
  "5 PDFs por mês",
];
const PRO_FEATURES = [
  "Tudo do plano gratuito",
  "PDFs ilimitados",
  "Relatório mensal consolidado",
  "Pesagens parciais de várias fazendas",
  "Suporte prioritário",
];

export default function Upgrade() {
  const { user } = useAuth();
  const [loading, setLoading] = useState("");
  const isPro = user?.plan === "pro";

  const go = async (lookupKey) => {
    setLoading(lookupKey);
    try {
      const url = await startCheckout(lookupKey);
      window.location.href = url;
    } catch {
      toast.error("Não foi possível iniciar o pagamento");
      setLoading("");
    }
  };

  return (
    <div className="space-y-8" data-testid="upgrade-page">
      <div className="text-center max-w-xl mx-auto">
        <span className="inline-flex items-center gap-2 rounded-full bg-gado-gold/15 text-gado-gold px-4 py-1.5 text-sm font-medium mb-4">
          <Crown weight="fill" size={16} /> GadoPro Pro
        </span>
        <h1 className="font-cabinet text-3xl md:text-4xl font-bold text-gado-ink tracking-tight">
          Menos calculadora, mais gado.
        </h1>
        <p className="text-gado-muted mt-3">
          Desbloqueie PDFs ilimitados, relatórios mensais e pesagens parciais.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
        {/* Free */}
        <div className="rounded-2xl border border-gado-line bg-white p-8">
          <p className="text-sm uppercase tracking-widest text-gado-muted">Gratuito</p>
          <p className="font-cabinet text-4xl font-bold text-gado-ink mt-2">R$ 0</p>
          <p className="text-gado-muted text-sm mb-6">para sempre</p>
          <ul className="space-y-3">
            {FREE_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2 text-gado-ink text-sm">
                <Check size={18} className="text-gado-green shrink-0 mt-0.5" /> {f}
              </li>
            ))}
          </ul>
          <Button disabled variant="outline" className="w-full mt-8">
            {isPro ? "Plano atual: Pro" : "Seu plano atual"}
          </Button>
        </div>

        {/* Pro */}
        <div className="rounded-2xl border-2 border-gado-green bg-gado-green text-white p-8 relative overflow-hidden">
          <div className="absolute top-0 right-0 bg-gado-gold text-gado-ink text-xs font-bold px-4 py-1.5 rounded-bl-xl">
            MAIS POPULAR
          </div>
          <p className="text-sm uppercase tracking-widest text-gado-goldLight">Pro</p>
          <p className="font-cabinet text-4xl font-bold mt-2">{formatBRL(39.9)}</p>
          <p className="text-white/70 text-sm mb-6">por mês · ou {formatBRL(399)}/ano</p>
          <ul className="space-y-3">
            {PRO_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm">
                <Check size={18} className="text-gado-goldLight shrink-0 mt-0.5" /> {f}
              </li>
            ))}
          </ul>
          <div className="mt-8 space-y-2">
            <Button
              onClick={() => go("gadopro_pro_monthly")}
              disabled={isPro || !!loading}
              data-testid="checkout-monthly-button"
              className="w-full bg-gado-gold hover:bg-gado-goldLight text-gado-ink font-semibold"
            >
              <Lightning weight="fill" size={18} className="mr-1" />
              {isPro ? "Você já é Pro" : loading === "gadopro_pro_monthly" ? "Redirecionando…" : "Assinar mensal"}
            </Button>
            {!isPro && (
              <Button
                onClick={() => go("gadopro_pro_yearly")}
                disabled={!!loading}
                data-testid="checkout-yearly-button"
                variant="outline"
                className="w-full border-white/30 bg-transparent text-white hover:bg-white/10"
              >
                {loading === "gadopro_pro_yearly" ? "Redirecionando…" : "Assinar anual (2 meses grátis)"}
              </Button>
            )}
          </div>
        </div>
      </div>
      <p className="text-center text-xs text-gado-muted">
        Pagamento seguro via Stripe · Cartão de teste: 4242 4242 4242 4242
      </p>
    </div>
  );
}
